import React, { forwardRef } from 'react';
import { cn } from '@/src/utils';

export interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, ...props }, ref) => {
    const disabledTextAreaStyle = props.disabled
      ? 'bg-gray1 border-gray3 text-[#a8aeb5] resize-none'
      : '';

    return (
      <textarea
        className={cn(
          'flex w-full rounded-md border border-input px-3 py-2 ring-offset-background placeholder:text-b16r placeholder:text-gray4 focus-visible:border-gray9 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed',
          disabledTextAreaStyle,
          className,
        )}
        ref={ref}
        {...props}
        value={props.value === undefined ? '' : props.value}
      />
    );
  },
);

export default TextArea;
